module.exports = __webpack_public_path__ + "static/media/feat-underground-img3.46686ecb.jpg";